// Fresh, bounded location acquisition. No cached pickup or fabricated fix.
export function requestFreshRouteLocation(geolocation = globalThis.navigator?.geolocation, onCheckpoint = () => {}) {
  return new Promise((resolve, reject) => {
    let settled = false;
    let timer;
    const finish = (error, value) => {
      if (settled) return;
      settled = true; clearTimeout(timer);
      if (error) reject(new Error(error)); else resolve(value);
    };
    const note = (name, details) => { try { onCheckpoint(name, details); } catch (_) { /* diagnostics never block recovery */ } };
    note("location_request", { permission_state: "unknown" });
    if (!geolocation?.getCurrentPosition) {
      note("location_result", { outcome: "blocked", permission_state: "unavailable" });
      finish("Location is unavailable. Your lesson is still active."); return;
    }
    timer = setTimeout(() => { note("location_result", { outcome: "failed", error_code: "timeout" }); finish("Location timed out. Retry when safely parked."); }, 16000);
    try {
      geolocation.getCurrentPosition(position => {
        const { latitude, longitude, accuracy } = position?.coords || {};
        const captured = position?.timestamp;
        if (![latitude, longitude, accuracy, captured].every(Number.isFinite)
            || Math.abs(latitude) > 90 || Math.abs(longitude) > 180
            || accuracy < 0 || accuracy > 100 || Date.now() - captured > 30000
            || captured - Date.now() > 5000) {
          note("location_result", { outcome: "failed", permission_state: "granted", error_code: "invalid_location" });
          finish("A fresh, more accurate location is needed. Retry when safely parked."); return;
        }
        note("location_result", { outcome: "ok", permission_state: "granted", accuracy_bucket: accuracy });
        finish(null, { latitude, longitude, accuracy_metres: accuracy, captured_at: new Date(captured).toISOString() });
      }, error => {
        const denied = error?.code === 1;
        note("location_result", { outcome: denied ? "blocked" : "failed", permission_state: denied ? "denied" : "unknown", error_code: denied ? "permission_denied" : error?.code === 3 ? "timeout" : "position_unavailable" });
        finish(denied
          ? "Location access was denied. Your lesson is still active; check location access before retrying."
          : "A location could not be obtained. Your lesson is still active; retry when parked.");
      },
      { enableHighAccuracy: false, maximumAge: 0, timeout: 15000 });
    } catch {
      note("location_result", { outcome: "blocked", permission_state: "unavailable" });
      finish("Location is unavailable. Your lesson is still active.");
    }
  });
}
